/**
 * VCDR Backend Public APIs
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { HostSummary } from './hostSummary';
import { SddcSummary } from './sddcSummary';


export interface VmcInfoSummary { 
    /**
     * Staging vs Production
     */
    env: string;
    hosts: HostSummary;
    /**
     * Number of orgs scanned for SDDCS in given env
     */
    num_orgs: number;
    /**
     * Number of orgs skipped (likely due to env mis-match or not onboarded properly in VMC)
     */
    num_orgs_skipped: number;
    /**
     * Number of orgs with valid VMC AWS shadow accounts assigned to it
     */
    num_orgs_with_vmc_shadow_accounts: number;
    /**
     * Number of unique VMC AWS shadow accounts assigned to given set of orgs
     */
    num_vmc_shadow_accounts: number;
    sddcs: SddcSummary;
}

